import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const RowLabel = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    color: ${theme.colors.secondary};
    white-space: normal;
  `}
`

export const AccountIconWrapper = styled(Box)<{ color: string }>`
  ${({ color }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 15px;
    height: 15px;
    color: ${color};

    svg {
      width: 15px !important;
      height: 15px !important;
    }

    & > div {
      min-width: 15px !important;
    }
  `}
`

export const IconWrapper = styled(Box)<{ color: string }>`
  ${({ color }) => css`
    display: flex;
    color: ${color};
  `}
`

// inline: valor e tendência na mesma linha (linha de total — GP)
export const CellWrapper = styled(Box, { shouldForwardProp: (prop) => prop !== 'inline' })<{ inline?: boolean }>`
  display: flex;
  flex-direction: ${({ inline }) => (inline ? 'row' : 'column')};
  align-items: ${({ inline }) => (inline ? 'center' : 'flex-end')};
  justify-content: flex-end;
  gap: ${({ inline }) => (inline ? '6px' : '2px')};
  white-space: ${({ inline }) => (inline ? 'nowrap' : 'normal')};
`

export const CellValue = styled(Box)`
  font-size: 14px;
`

export const CellTrend = styled(Box)`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #2a295c;
`

export const WeekHeader = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  line-height: 1.3;
  white-space: normal;
`


export const GmLabel = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    color: ${theme.colors.blue.dark};
  `}
`
